/* §70 Ban-97 — homepage (sections/ez-home-*.liquid).
   1. Recipient tabs: switch the product row in place. No address change (no fake FB PageView / GA page_view),
      one click + one keydown listener on window (capture), nothing measured while tapping.
      "All" = cards marked data-a; a tab = the first data-lim cards whose data-g has the tag. Computer shows the
      first 4 of what is visible (.ezh-x on the rest).
   Ban-98: the same tabs drive "Gifts for every occasion" (data-g = o1, o2…); the orange button takes the tab's
      data-href / data-btn.
   3. Reviews (Ban-98): "Read more" shows only where the 3-line text is cut (checked once after load and when the
      row changes size, never while tapping); it opens the whole review in window.ezSheet (from the bottom on phones).
   4. "Made with their name on it" (Ban-98): the names type themselves (110 ms a letter, 1.8 s pause), only while
      the card is on screen; off with reduced motion (the first name stays).
   5. Banner carousel (Ban-99): native swipe (scroll-snap). The visible slide comes from an IntersectionObserver
      (no measuring while scrolling); the track width comes from a ResizeObserver, so a dot/arrow tap only calls
      scrollTo. Optional auto-play (data-auto seconds): only on screen, tab visible, not touched/hovered in the
      last 8 s, never with reduced motion.
   6. Ban-102: computer rows show 6 (.ezh-y on the rest); header magnifier back once the phone search bar is gone.
   2. Phone search bar: the bold word rotates every 2.6 s (one text node), paused while the tab is hidden or the
      bar is off screen, off with reduced motion. Tapping the bar is handled by ez-search.js (data-ezs-open). */
(function () {
  "use strict";
  if (window.__ezHome) return;
  window.__ezHome = 1;

  /* Ban-100: "Gifts for every occasion" prints only its first tab; other tabs are fetched once
     (/collections/<handle>?section_id=ez-home-rail), ahead of time when the block nears the screen. */
  function ensure(rail, tab) {
    var k = tab.getAttribute("data-k"), src = tab.getAttribute("data-src");
    rail.__ld = rail.__ld || {};
    if (!rail.hasAttribute("data-ezh-lazy") || !k || !src || rail.querySelector('[data-g="' + k + '"]')) return Promise.resolve(true);
    if (rail.__ld[k]) return rail.__ld[k];
    rail.__ld[k] = fetch(src + (src.indexOf("?") > -1 ? "&" : "?") + "section_id=ez-home-rail", { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var t = document.createElement("template");
        t.innerHTML = html;
        var lis = t.content.querySelectorAll("[data-ezh-part] > li"), frag = document.createDocumentFragment();
        for (var i = 0; i < lis.length; i++) { lis[i].setAttribute("data-g", k); lis[i].hidden = true; frag.appendChild(lis[i]); }
        rail.appendChild(frag);
        return lis.length > 0;
      })
      .catch(function () { rail.__ld[k] = null; return false; });
    return rail.__ld[k];
  }
  function prefetch(rail, box) {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[es.length - 1].isIntersecting) return;
      io.disconnect();
      var tabs = box.querySelectorAll(".ezh-tab[data-src]"), i = 0;
      var next = function () {
        if (i >= tabs.length) return;
        var t = tabs[i++];
        var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
        idle(function () { ensure(rail, t).then(next); });
      };
      next();
    }, { rootMargin: "800px 0px" });
    io.observe(rail);
  }

  function pick(tab) {
    var box = tab.closest("[data-ezh-tabs]");
    if (!box || tab.getAttribute("aria-selected") === "true") return;
    var k = tab.getAttribute("data-k") || "";
    var tabs = box.querySelectorAll(".ezh-tab");
    for (var i = 0; i < tabs.length; i++) tabs[i].setAttribute("aria-selected", tabs[i] === tab ? "true" : "false");
    var rail = box.parentNode.querySelector("[data-ezh-rail]");
    if (!rail) return;
    if (rail.hasAttribute("data-ezh-lazy") && k && !rail.querySelector('[data-g="' + k + '"]')) {
      rail.setAttribute("aria-busy", "true");
      ensure(rail, tab).then(function (ok) {
        rail.removeAttribute("aria-busy");
        if (tab.getAttribute("aria-selected") !== "true") return;
        if (!ok) { var h = tab.getAttribute("data-href"); if (h) location.href = h; return; }
        show(box, rail, tab, k);
      });
      return;
    }
    show(box, rail, tab, k);
  }
  function show(box, rail, tab, k) {
    var lim = parseInt(rail.getAttribute("data-lim"), 10) || 16;
    var n = 0, li = rail.children;
    for (var j = 0; j < li.length; j++) {
      var c = li[j], on;
      if (!k) on = c.hasAttribute("data-a");
      else on = n < lim && (" " + (c.getAttribute("data-g") || "") + " ").indexOf(" " + k + " ") > -1;
      if (on) n++;
      c.hidden = !on;
      c.classList.toggle("ezh-x", on && n > 4);
      c.classList.toggle("ezh-y", on && n > 6);
    }
    rail.scrollLeft = 0;
    var more = tab.getAttribute("data-href") && box.parentNode.querySelector("[data-ezh-more]");
    if (more) { more.href = tab.getAttribute("data-href"); more.textContent = tab.getAttribute("data-btn") || more.textContent; }
  }

  function esc(t) { var d = document.createElement("div"); d.textContent = t; return d.innerHTML; }
  function openReview(li) {
    if (typeof window.ezSheet !== "function") return;
    var img = li.querySelector("img"), q = li.querySelector(".ezh-q"), who = li.querySelector("small"), st = li.querySelector(".ezh-stars");
    window.ezSheet({ title: (li.querySelector("b") || {}).textContent || "Review", cls: "ezh-rsheet", fill: function (body) {
      body.innerHTML = '<div class="ezh-rs">' + (img ? '<img src="' + img.currentSrc.replace(/"/g, "&quot;") + '" alt="' + esc(img.alt) + '">' : "") +
        (st ? '<span class="ezh-stars">' + st.innerHTML + "</span>" : "") + "<p>" + esc(q ? q.textContent : "") + "</p>" +
        (who ? "<small>" + who.innerHTML + "</small>" : "") + "</div>";
    } });
  }

  window.addEventListener("click", function (e) {
    var rm = e.target && e.target.closest ? e.target.closest(".ezh [data-ezh-rm]") : null;
    if (rm) { e.preventDefault(); e.stopImmediatePropagation(); openReview(rm.closest("li")); return; }
    var card = e.target && e.target.closest ? e.target.closest(".ezh [data-ezh-quotes] > li") : null;
    if (card) { e.preventDefault(); e.stopImmediatePropagation(); openReview(card); return; }
    var t = e.target && e.target.closest ? e.target.closest(".ezh .ezh-tab") : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pick(t);
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var rm = e.target && e.target.closest ? e.target.closest(".ezh [data-ezh-quotes] > li") : null;
    if (rm && e.target === rm) { e.preventDefault(); e.stopImmediatePropagation(); openReview(rm); return; }
    var t = e.target && e.target.closest ? e.target.closest(".ezh .ezh-tab") : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pick(t);
  }, true);

  function words() {
    var a = document.querySelector(".ezh [data-ezh-words]");
    var kw = a && a.querySelector(".ezh-kw");
    if (!kw || !kw.firstChild) return;
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var list = (a.getAttribute("data-ezh-words") || "").split(",").map(function (w) { return w.trim(); }).filter(Boolean);
    if (list.length < 2) return;
    var i = 0, seen = true;
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; }).observe(a);
    setInterval(function () {
      if (document.hidden || !seen) return;
      i = (i + 1) % list.length;
      kw.classList.add("is-out");
      setTimeout(function () { kw.firstChild.nodeValue = list[i]; kw.classList.remove("is-out"); }, 180);
    }, 2600);
  }
  function cuts() {
    var lists = document.querySelectorAll(".ezh [data-ezh-quotes]");
    var check = function (ul) {
      var qs = ul.querySelectorAll(".ezh-q");
      for (var i = 0; i < qs.length; i++) {
        var on = qs[i].scrollHeight > qs[i].clientHeight + 2, rm = qs[i].nextElementSibling;
        if (!rm) continue;
        rm.classList.toggle("is-on", on);
      }
    };
    for (var i = 0; i < lists.length; i++) {
      (function (ul) {
        var w = 0;
        if ("ResizeObserver" in window) new ResizeObserver(function (es) { var nw = Math.round(es[0].contentRect.width); if (nw !== w) { w = nw; requestAnimationFrame(function () { check(ul); }); } }).observe(ul);
        else check(ul);
      })(lists[i]);
    }
  }

  function typing() {
    var card = document.querySelector(".ezh [data-ezh-names]");
    if (!card) return;
    var nm = card.querySelector("[data-ezh-name]"), fd = card.querySelector("[data-ezh-field]");
    var list = (card.getAttribute("data-ezh-names") || "").split(",").map(function (w) { return w.trim(); }).filter(Boolean);
    if (!nm || !list.length || (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches)) return;
    var seen = false, timer = 0, i = 0, c = list[0].length;
    var step = function () {
      timer = 0;
      if (!seen || document.hidden) return;
      var w = list[i % list.length];
      if (c >= w.length) { i++; c = 0; timer = setTimeout(step, 1800); return; }
      c++;
      nm.textContent = fd.textContent = w.slice(0, c);
      timer = setTimeout(step, c >= w.length ? 1800 : 110);
      if (c >= w.length) { i++; c = 0; }
    };
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
      seen = es[es.length - 1].isIntersecting;
      if (seen && !timer) timer = setTimeout(step, 600);
    }).observe(card);
  }

  var SL = [];
  function slider(root) {
    var track = root.querySelector("[data-ezh-track]");
    var slides = track ? track.querySelectorAll("[data-ezh-slide]") : [];
    if (slides.length < 2) return;
    var o = { root: root, track: track, n: slides.length, i: 0, w: 0, touched: 0, seen: false };
    var dots = root.querySelectorAll("[data-ezh-dot]");
    o.paint = function () {
      for (var d = 0; d < dots.length; d++) {
        if (d === o.i) dots[d].setAttribute("aria-current", "true"); else dots[d].removeAttribute("aria-current");
      }
    };
    if ("ResizeObserver" in window) new ResizeObserver(function (es) { o.w = es[0].contentRect.width; }).observe(track);
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        for (var k = 0; k < es.length; k++) {
          if (es[k].intersectionRatio > 0.55) {
            o.i = Array.prototype.indexOf.call(slides, es[k].target);
            o.paint();
          }
        }
      }, { root: track, threshold: [0.55] });
      for (var k = 0; k < slides.length; k++) io.observe(slides[k]);
      new IntersectionObserver(function (es) { o.seen = es[es.length - 1].isIntersecting; }).observe(root);
    }
    var hold = function () { o.touched = Date.now(); };
    root.addEventListener("pointerdown", hold, { passive: true });
    root.addEventListener("pointerenter", hold, { passive: true });
    root.addEventListener("wheel", hold, { passive: true });
    root.addEventListener("focusin", hold);
    root.__ezh = o;
    SL.push(o);
    var sec = parseInt(root.getAttribute("data-auto"), 10) || 0;
    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (sec > 0 && !reduce) setInterval(function () {
      if (document.hidden || !o.seen || Date.now() - o.touched < 8000) return;
      go(o, (o.i + 1) % o.n);
    }, sec * 1000);
  }
  function go(o, i) {
    if (!o.w) o.w = o.track.clientWidth;
    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    o.i = i;
    o.paint();
    o.track.scrollTo({ left: i * o.w, behavior: reduce ? "auto" : "smooth" });
  }
  function nav(t) {
    var root = t.closest("[data-ezh-slider]"), o = root && root.__ezh;
    if (!o) return;
    o.touched = Date.now();
    if (t.hasAttribute("data-ezh-dot")) go(o, parseInt(t.getAttribute("data-ezh-dot"), 10) || 0);
    else go(o, (o.i + (parseInt(t.getAttribute("data-ezh-go"), 10) || 1) + o.n) % o.n);
  }
  window.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest(".ezh [data-ezh-dot], .ezh [data-ezh-go]") : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nav(t);
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target && e.target.closest ? e.target.closest(".ezh [data-ezh-dot], .ezh [data-ezh-go]") : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nav(t);
  }, true);

  /* Ban-102: phones, homepage: the header magnifier shows again once the search bar is off screen
     (class on the header section, one IntersectionObserver, no scroll listener) */
  function headerSearch() {
    var bar = document.querySelector(".ezh .ezh-search"), sh = document.querySelector(".section-header");
    if (!bar || !sh || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es) { sh.classList.toggle("ezh-scrolled", !es[es.length - 1].isIntersecting); }, { rootMargin: "-64px 0px 0px 0px" }).observe(bar);
  }
  function start() {
    words(); cuts(); typing(); headerSearch();
    var lz = document.querySelectorAll(".ezh [data-ezh-rail][data-ezh-lazy]");
    for (var z = 0; z < lz.length; z++) { var bx = lz[z].closest(".ezh-in").querySelector("[data-ezh-tabs]"); if (bx) prefetch(lz[z], bx); }
    var s = document.querySelectorAll(".ezh [data-ezh-slider]");
    for (var i = 0; i < s.length; i++) slider(s[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
